import React from 'react';
import {formatNow} from "../../services/UtilityService";

const Footer = ({ page }) => {
    return (
        <div className='PageFooter'>
            <div className='PageFooter__layout'>
                <div className='PageFooter__logo'>
                    <img src='https://files.tablegroup.com/wp-content/uploads/2022/06/14030053/logo.png' alt={''} />
                </div>

                <div className='PageFooter__textContainer'>
                    <p className='PageFooter__paragraph'>Tablegroup.com</p>
                    <p className='PageFooter__paragraph'>
                        &copy; Copyright {formatNow()} The Table Group, Inc.
                    </p>
                </div>

                <div className='PageFooter__pageContainer'>
                    <p className='PageFooter__page'>
                        {page}
                        <span className='PageFooter__pageGear'>
							<img src='https://files.tablegroup.com/wp-content/uploads/2022/05/20095359/aW9Eo8vA-team_assessment_logo_tools.svg' alt={''} />
						</span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Footer;
